import React from 'react';
import PropTypes from 'prop-types';
import { getTeamLogoUrl } from '~shared/utils/sportsbook';
import './style.scss';

const EventName = ({
    shouldShowTeamLogo = false,
    sportSlug,
    categorySlug,
    slug,
    name,
    isHome,
    isUsFormat,
}) => {
    const abbreviation = isUsFormat && !isHome ? ' @' : '';

    return (
        <>
            {Boolean(shouldShowTeamLogo) && (
                <img
                    src={getTeamLogoUrl(sportSlug, categorySlug, slug)}
                    className="event-name__logo"
                />
            )}
            <span key={slug} className="event-name__text">
                {name}
                {abbreviation}
            </span>
        </>
    );
};

EventName.propTypes = {
    shouldShowTeamLogo: PropTypes.bool,
    isUsFormat: PropTypes.bool,
    isHome: PropTypes.bool,
    sportSlug: PropTypes.string.isRequired,
    categorySlug: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
};

export default EventName;
